// extracted by mini-css-extract-plugin
export default {"manage_layout":"ChartPage_manage_layout__NrIsk"};